export default class SrcSetVerify {
    static verify(urlBase, format, callback) {
        if (!urlBase || !format) {
            callback(null);
            return;
        }

        const baseForatURL = urlBase.split('/');
        const lastURL = baseForatURL.pop();

        if (!lastURL) {
            callback(null);
            return;
        }

        const joinBaseForatURL = baseForatURL.join('/');
        const lastURLArray = lastURL.split('.');

        if (lastURLArray.length < 2) {
            callback(null);
            return;
        }

        const createURL = `${joinBaseForatURL}/${lastURLArray[0]}-format-${format}.${lastURLArray[1]}`;

        const img = new Image();

        img.onload = () => callback(createURL);
        img.onerror = () => callback(null);

        img.src = createURL;
    }
}
